import FileExplorerPage from './FileExplorerPage';

export default FileExplorerPage;
